function isSuccessHttpStatus(status?: number | null) {
	if (!status) return false;

	status = status as number;
	return status >= 200 && status < 300;
}

export default isSuccessHttpStatus;
